import React from 'react'
import getStudentThresholdData from '../../../../helpers/assessment/getStudentThresholdData'
import totalStudentThresholdCount from '../../../../helpers/assessment/totalStudentThresholdCount'

export default function StudentThreshold ({threshold, thresholdBreaks}) {
  let rows = []
  const data = getStudentThresholdData(threshold.composite, thresholdBreaks.student)

  data.forEach((range, n) => {
    let title = `${range.min} to ${range.max}`
    if (n === 0) {
      title = `${data[n + 1].max - 1} and below`
    } else if (n + 1 === data.length) {
      title = `${data[n - 1].max + 1} and above`
    } else if (range.max === range.min) {
      title = `${range.max}`
    }
    let color = data.length - n - 1
    if (color > 5) {
      color = 5
    } else if (color < 0) {
      color = 0
    }


    rows.push(
			<tr className={`green${color}`} key={`studentThresh${n}`}>
				<td>{title}</td>
				<td>{range.count}</td>
			</tr>
    )
  })
  
  const total = totalStudentThresholdCount(data)
  rows.push(
    <tr className={`green5`} key={`studentThreshTot`}>
      <td>Total</td>
      <td>{total}</td>
    </tr>
  )

  return (
    <div className="student-count">
      <h4>Student Count</h4>
      <h5>By Composite Score</h5>
      <table>
        <tbody>
          <tr className="green5">
            <th>Score</th>
            <th>Number of Students</th>
          </tr>
          {rows}
        </tbody>
      </table>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/Threshold/StudentThreshold.js